import styled from 'styled-components';
import { config } from '../../../../../../../components/dashboards/config';

export default styled.div`
  width: 100%;

  .chart-container {
    height: 280px;  
    padding: ${config.PADDING - 4}px ${config.PADDING}px;
  }
`;
